import React from 'react'
import Main from '../../../components/HOC/Main'
import MemberForm from '../../../components/pages/MemberForm'

const AddMemberPage = () => {
    return (
        <Main crumbs={[{ title: "members" }, { title: "Add member" }]}>
            <MemberForm />
        </Main>
    )
}

export default AddMemberPage